import { render, staticRenderFns } from "./aaa.vue?vue&type=template&id=68af7a26&scoped=true&"
import script from "./aaa.vue?vue&type=script&lang=js&"
export * from "./aaa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68af7a26",
  null
  
)

export default component.exports